module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-13.96d13a54.png";